import React from 'react';

const PromotionRuleFormModal = React.lazy(() => import('../components/FormModal'));
const promotionRuleModalRegistry = {
    core_promotionRuleId: PromotionRuleFormModal
};
export default promotionRuleModalRegistry;
